



import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import CampoHashCadastro from "../components/CampoHashCadastro/CampoHashCadastro";
import Carregamento from "../components/Carregamento/Carregamento";
import DropdownPadrao from "../components/DropdownPadrao/DropdownPadrao";
import FormularioPadrao, { TAMANHO_FORMULARIO } from "../components/FormularioPadrao/FormularioPadrao";
import InputPadrao from "../components/InputPadrao/InputPadrao";
import ModalSistemas from "../components/ModalSistemas/ModalSistemas";
import TogglePadrao from "../components/TogglePadrao/TogglePadrao";
import { useCliente, useUnidade } from "../hooks/DropdownHooks";
import api from "../services/api";
import { APP_ROUTES } from "../services/app_routes";
import { TipoFormatacao } from "../utils/FormatacaoUtils";
import Mensagens from "../utils/MensagemUtils";
import NotificacaoUtils from "../utils/NotificacaoUtils";
import { TipoValidacao, ValidacaoUtils } from "../utils/ValidacaoUtils";
import "./Cadastros.css";

export default function CadastroChaves({ isEdit = false }) {

    const { id } = useParams();
    const navigate = useNavigate();
    const [carregando, setCarregando] = useState(false);
    const [dadosChavesCarregados, setDadosChavesCarregados] = useState(false);
    const [errors, setErrors] = useState({});
    const [chaveApi, setChaveApi] = useState();
    const { itens: clientesFk, carregando: carregandoclientes } = useCliente();
    const [mostrarModal, setMostrarModal] = useState(false);

    const [chaves, setChaves] = useState({
        id: 0,
        descricao: '',
        idCliente: '',
        sistemaId: '',
        razaoSocial: '',
        situacaoCadastro: true,
        unidade: '',
        limiteDiario: '',
        limiteSemanal: '',
        limiteMensal: '',
    });

    const [clienteSelecionado, setClienteSelecionado] = useState(chaves.idCliente || null);
    const { itens: unidadefk, carregando: carregandoUnidade, erro: errorUnidade } = useUnidade(clienteSelecionado);

    useEffect(() => {
        setChaves(prev => ({ ...prev, unidade: '' }));
        if (errorUnidade) {
            NotificacaoUtils.erro(Mensagens.DESENVOLVIMENTO.ERRO.UNIDADE_N_ENCONTRADA);
        }

    }, [errorUnidade, unidadefk]);


    const carregamentoGeral = () => carregando || carregandoclientes

    const buscarChave = async (idChaves) => {
        setCarregando(true);
        try {
            const apiResponse = await api.get(`/apiKey_/${idChaves}`);
            if (apiResponse.success && apiResponse.data) {
                const dadosChaves = apiResponse.data;

                setChaves({
                    id: dadosChaves.id || 0,
                    descricao: dadosChaves.descricao || '',
                    idCliente: String(dadosChaves.sistemaDTO?.clienteDTO?.id || ''),
                    sistemaId: String(dadosChaves.sistemaDTO?.id || dadosChaves.sistemaId || ''),
                    razaoSocial: dadosChaves.sistemaDTO?.clienteDTO?.razaoSocial || '',
                    situacaoCadastro: dadosChaves.situacaoCadastro === 'Ativo',
                    unidade: dadosChaves.sistemaDTO?.unidade || '',
                    limiteDiario: dadosChaves.limiteDiario || '',
                    limiteSemanal: dadosChaves.limiteSemanal || '',
                    limiteMensal: dadosChaves.limiteMensal || '',
                });

                setChaveApi(dadosChaves.hashKey)

                setDadosChavesCarregados(true);
            } else {
                NotificacaoUtils.erro(Mensagens.DESENVOLVIMENTO.ERRO.CARREGAR);
                navigate(APP_ROUTES.DESENVOLVIMENTO_CHAVES);
            }
        } catch (error) {
            console.error("Erro ao carregar empresa:", error);
            NotificacaoUtils.erro(Mensagens.DESENVOLVIMENTO.ERRO.CARREGAR);
            navigate(APP_ROUTES.DESENVOLVIMENTO_CHAVES);
        } finally {
            setCarregando(false);
        }
    };

    useEffect(() => {
        if (isEdit && id && !dadosChavesCarregados) {
            buscarChave(id);
        }
    }, [isEdit, id, dadosChavesCarregados]);

    const handleInputChange = (e, field) => {
        const val = e.target.value;
        setChaves(prev => ({
            ...prev,
            [field]: val,
        }));

        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: null,
            }));
        }
    };

    const handleSwitchChange = (novoValor, field) => {
        setChaves(prev => ({
            ...prev,
            [field]: novoValor,
        }));
    };

    const validarFormulario = () => {
        const retornoValidacao = ValidacaoUtils.validateForm(
            chaves,
            TipoValidacao.CHAVES_CRIAR
        );

        if (!retornoValidacao.success) {
            setErrors(retornoValidacao.errors);
            return false;
        }

        return true;
    };

    const handleCadastro = async () => {
        if (!validarFormulario()) return;

        setCarregando(true);

        try {
            const dadosChaves = {
                id: isEdit ? chaves.id : null,
                descricao: chaves.descricao,
                "sistemaId": isEdit ? (chaves.sistemaId || chaves.idCliente) : chaves.unidade,
                "limiteRequisicaoDiario": chaves.limiteDiario,
                "limiteRequisicaoSemanal": chaves.limiteSemanal,
                "limiteRequisicaoMensal": chaves.limiteMensal,
                situacaoCadastro: chaves.situacaoCadastro ? 'ATIVO' : 'INATIVO',
            };

            const apiResponse = isEdit
                ? await Promise.resolve(api.put(`/apiKey_`, dadosChaves))
                : await Promise.resolve(api.post(`/apiKey_`, dadosChaves));

            if (!apiResponse.success) {
                NotificacaoUtils.erro(apiResponse.message || Mensagens.DESENVOLVIMENTO.ERRO.ATUALIZAR_TENTE_NOVAMENTE);
            } else {
                NotificacaoUtils.sucesso(isEdit ? Mensagens.DESENVOLVIMENTO.ATUALIZADO_SUCESSO : Mensagens.DESENVOLVIMENTO.CADASTRADO_SUCESSO);
                if (!isEdit) {
                    await buscarChave(apiResponse.data.id)
                    setMostrarModal(true);
                } else {
                    navigate(APP_ROUTES.DESENVOLVIMENTO_CHAVES);
                }
            }
        } catch (error) {
            console.error("Erro ao salvar empresa:", error);
            NotificacaoUtils.erro(Mensagens.DESENVOLVIMENTO.ERRO.ATUALIZAR_TENTE_NOVAMENTE);
        } finally {
            setCarregando(false);
        }
    };

    const handleCancel = () => {
        navigate(APP_ROUTES.DESENVOLVIMENTO_CHAVES);
    };

    return (
        <div>
            {carregamentoGeral() && <Carregamento />}

            {mostrarModal && <ModalSistemas
                aberto={mostrarModal}
                titulo="Chave Criada com sucesso!"
                subtitulo="Copie a chave, seu cliente e sua unidade abaixo."
                onClose={() => {
                    setMostrarModal(false);
                    navigate(APP_ROUTES.DESENVOLVIMENTO_CHAVES);
                }}
                txtBtnConfirmar="Fechar"
                onConfirmar={() => {
                    setMostrarModal(false);
                    navigate(APP_ROUTES.DESENVOLVIMENTO_CHAVES);
                }}
            >
                <div className="modal-hash-lista">
                    <CampoHashCadastro value={chaveApi} title="Hash da Chave" qtdEncript={0.5} />
                    <CampoHashCadastro value={chaves.razaoSocial} title="Cliente" usarCorAzul={false} />
                    <CampoHashCadastro value={chaves.unidade} title="Unidade" usarCorAzul={false} />
                </div>
            </ModalSistemas>
            }

            <FormularioPadrao
                titulo={isEdit ? Mensagens.DESENVOLVIMENTO.EDITAR_CHAVE : Mensagens.DESENVOLVIMENTO.CADASTRO_CHAVE}
                subtitulo={
                    isEdit ? Mensagens.DESENVOLVIMENTO.SUB_EDITAR_CHAVE : Mensagens.DESENVOLVIMENTO.SUB_EDITAR_CHAVE
                }
                tituloInterno={Mensagens.INFORMACOES_GERAIS}
                tamanho={TAMANHO_FORMULARIO.PADRAO}
                iconeBotao={<FaCheck />}
            >
                <div className="inputs-flex">
                    <div className={`linha-flex linha-limites ${isEdit ? 'linha-edicao' : ''}`}>
                        {isEdit && (<div className="linha-edicao-chave">
                            <CampoHashCadastro value={chaveApi} title="Chave de Api" qtdEncript={0.5} />
                        </div>)}
                        <InputPadrao
                            label={Mensagens.DESENVOLVIMENTO.DESCRICAO}
                            placeholder={Mensagens.DESENVOLVIMENTO.HASH_MENSAGEM_CHAVE_PLACEHOLDER}
                            required={true}
                            value={chaves.descricao}
                            erroMensagem={errors.descricao}
                            onChange={e => handleInputChange(e, 'descricao')}
                        />
                    </div>
                    <div className="linha-flex"></div>
                    <div className={isEdit ? "linha-edicao-info" : "linha-geral"}>
                        {
                            isEdit
                                ? (<CampoHashCadastro value={chaves.razaoSocial} title="Cliente" usarCorAzul={false} />)
                                : <DropdownPadrao
                                    label={'Cliente'}
                                    showFilter={true}
                                    options={clientesFk}
                                    value={chaves.idCliente}
                                    name="idCliente"
                                    erroMensagem={errors.idCliente}
                                    onChange={e => {
                                        handleInputChange(e, 'idCliente');
                                        setClienteSelecionado(e.target.value);
                                    }}
                                />
                        }
                        {
                            isEdit
                                ? (<CampoHashCadastro value={chaves.unidade} title="Unidade" usarCorAzul={false} />)
                                : <div className={!clienteSelecionado || errorUnidade ? "dropdown-bloqueado" : ''}>
                                    <DropdownPadrao
                                        label={Mensagens.DESENVOLVIMENTO.UNIDADE}
                                        showFilter={true}
                                        options={unidadefk}
                                        value={chaves.unidade}
                                        name="unidade"
                                        erroMensagem={errors.unidade}
                                        disabled={!clienteSelecionado || errorUnidade}
                                        onChange={e => handleInputChange(e, 'unidade')}
                                    />
                                </div>
                        }

                        <TogglePadrao
                            label={Mensagens.EMPRESA.SITUACAO_CADASTRO}
                            value={chaves.situacaoCadastro}
                            disabled={!isEdit}
                            onChange={novoValor => handleSwitchChange(novoValor, 'situacaoCadastro')}
                        />

                    </div>
                </div>
            </FormularioPadrao>
            <FormularioPadrao

                tituloInterno={Mensagens.DESENVOLVIMENTO.LIMITES_REQUISICAO}
                subtituloInterno={Mensagens.DESENVOLVIMENTO.SUBTITLO_REQ}
                tamanho={TAMANHO_FORMULARIO.PADRAO}
                onSalvar={handleCadastro}
                txtBtnSalvar="Salvar"
                onCancelar={handleCancel}
                iconeBotao={<FaCheck />}
                dataCriacao={isEdit ? chaves.dataCriacao : null}
                dataAlteracao={isEdit ? chaves.dataAlteracao : null}
            >
                <div className="inputs-flex">
                    <div className="linha-flex linha-limites">
                        <InputPadrao
                            label={Mensagens.DESENVOLVIMENTO.LIMITE_DIARIO}
                            placeholder={0}
                            required={true}
                            value={chaves.limiteDiario}
                            tipoFormatador={TipoFormatacao.NUMERO}
                            type={InputPadrao.TipoInput.NUMBER}
                            erroMensagem={errors.limiteDiario}
                            onChange={e => handleInputChange(e, 'limiteDiario')}
                            style={{ textAlign: "right" }}
                            suffix="Requisições"
                        />
                        <InputPadrao
                            label={Mensagens.DESENVOLVIMENTO.LIMITE_SEMANAL}
                            placeholder={0}
                            required={true}
                            value={chaves.limiteSemanal}
                            tipoFormatador={TipoFormatacao.NUMERO}
                            type={InputPadrao.TipoInput.NUMBER}
                            erroMensagem={errors.limiteSemanal}
                            onChange={e => handleInputChange(e, 'limiteSemanal')}
                            style={{ textAlign: "right" }}
                            suffix="Requisições"
                        />
                        <InputPadrao
                            label={Mensagens.DESENVOLVIMENTO.LIMITE_MENSAL}
                            placeholder={0}
                            required={true}
                            value={chaves.limiteMensal}
                            tipoFormatador={TipoFormatacao.NUMERO}
                            type={InputPadrao.TipoInput.NUMBER}
                            erroMensagem={errors.limiteMensal}
                            onChange={e => handleInputChange(e, 'limiteMensal')}
                            style={{ textAlign: "right" }}
                            suffix="Requisições"
                        />

                    </div>
                </div>
            </FormularioPadrao>
        </div>
    );
}
